import axios, { CreateAxiosDefaults } from 'axios'

const projectId = import.meta.env.VITE_CUSTOM_GPT_PROJECT_ID as string

const commonCreateOptions: CreateAxiosDefaults = {
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${import.meta.env.VITE_CUSTOM_GPT_API_KEY as string}`
  }
}

export const baseApiClient = axios.create({
  ...commonCreateOptions,
  baseURL: `${import.meta.env.VITE_BASE_API_URL}projects/${projectId}/`
})

export const feedbackApiClient = axios.create({
  ...commonCreateOptions,
  baseURL: `${import.meta.env.VITE_FEEDBACK_API_URL}projects/${projectId}/`
})

export const miaApiClient = axios.create({
  baseURL: import.meta.env.VITE_MIA_API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})
